import axios from "axios";
import { ElmApp } from "types/elm";

import { getEnvironmentFromHost } from "./environment";
import { getTenantFromSubdomain } from "./tenant";

type Banner = {
  text: string;
  linkText?: string;
  linkUrl?: string;
};

async function fetchBanner(): Promise<Banner | null> {
  const tenant = getTenantFromSubdomain();
  const environment = getEnvironmentFromHost();

  try {
    const response = await axios.get(
      `/tenant-metadata/${environment}/${tenant}.json`
    );
    if (response.data?.banner && response.data.banner.text) {
      return response.data.banner as Banner;
    }
  } catch (e: any) {
    if (e.response && e.response.status === 404) {
      // there is no banner for this tenant -- do nothing
    } else {
      console.error(e);
    }
  }

  const response = await axios.get(
    `/tenant-metadata/${environment}/shared.json`
  );
  if (response.data?.banner && response.data.banner.text) {
    return response.data.banner as Banner;
  }

  return null;
}

export async function refreshBanner(_data: any, app: ElmApp): Promise<void> {
  const banner = await fetchBanner();
  app.ports.interopToElm.send({
    name: "setBanner",
    value: banner,
  });
}
